import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { AddressService } from '../../../core/services/address/address/address.service'
import { MatProgressBar } from '@angular/material/progress-bar'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { AddressClientEditFormComponent } from './address-client-edit-form/address-client-edit-form.component'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import {
  responseDefaultForm,
  validTreatList,
} from '../../../shared/utils/utils'
import { MatTooltip } from '@angular/material/tooltip'
import { NgClass } from '@angular/common'
import { SearchBankModel } from '../../../core/models/bank.model'
import { MatDivider } from '@angular/material/divider'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

@Component({
  selector: 'address-client-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatProgressBar,
    AddressClientEditFormComponent,
    FormClientSearchComponent,
    MatTooltip,
    NgClass,
    MatDivider,
    MatProgressSpinner,
  ],
  templateUrl: './address-client-edit.component.html',
  styleUrl: './address-client-edit.component.scss',
  providers: [AddressService],
  standalone: true,
})
export class AddressClientEditComponent implements OnInit, AfterViewInit {
  constructor(
    private addressService: AddressService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  loading: boolean = true
  loadingDelete: boolean = false

  @Output() response: EventEmitter<any> = new EventEmitter()
  @Input() idPerson: number = 0
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'addressType',
      key: 'tipoEndereco',
      description: 'Tipo endereço',
    },
    {
      keyColumn: 'postalCode',
      key: 'cep',
      description: 'Cep',
    },
    {
      keyColumn: 'street',
      key: 'logradouro',
      description: 'Logradouro',
    },
    {
      keyColumn: 'number',
      key: 'numero',
      description: 'Numero',
    },
    {
      keyColumn: 'neighborhood',
      key: 'bairro',
      description: 'Bairro',
    },
    {
      keyColumn: 'city',
      key: 'cidade',
      description: 'Cidade',
    },
    {
      keyColumn: 'latitude',
      key: 'latitude',
      description: 'Latitude',
    },
    {
      keyColumn: 'longitude',
      key: 'longitude',
      description: 'Longitude',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  page: number = 1
  rows: number = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()

  displayedColumns: string[] = [
    'addressType',
    'postalCode',
    'street',
    'number',
    'neighborhood',
    'city',
    'latitude',
    'longitude',
    'action',
  ]

  inputSearchAddress: any = { type: '', search: '' }
  listSearch: any = [
    {
      id: 'tipoEnderecoId',
      description: 'Tipo endereço',
      type: 'number',
      visible: false,
    },
    { id: 'cep', description: 'Cep', type: 'string', visible: false },
    {
      id: 'logradouro',
      description: 'Logradouro',
      type: 'string',
      visible: true,
    },
    { id: 'cidade', description: 'Cidade', type: 'string', visible: true },
    { id: 'estado', description: 'Estado', type: 'string', visible: true },
    { id: 'ativo', description: 'Ativo', type: 'boolean', visible: false },
  ]
  searchForm: any = { search: false, model: {} }

  ngOnInit(): void {
    this.getAddressByPerson()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    // if (this.table) {
    //   this.table.renderRows()
    // }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    // this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchAddress()
    } else {
      this.getAddressByPerson()
    }
  }

  getAddressByPerson() {
    this.loading = true
    this.addressService
      .listPagedAddressByPerson(this.idPerson, this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchAddress() {
    this.loading = true
    this.addressService
      .searchPagedAddress(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    let list = []
    if (validTreatList(response)) {
      for (let item of response.data) {
        list.push({
          ...item,
          ativo: item.ativo.toUpperCase() == 'S' ? 'Ativo' : 'Inativo',
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  updateItem(element: any) {
    this.item = { edit: true, data: element }
  }

  deleteItem(element: any) {
    this.clearItem()
    this.loadingDelete = true
    // this.addressService.deleteAddress({ id: element.id }).subscribe({
    this.addressService.deleteAddress(element.id).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.uploadList()
        this.loadingDelete = false
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
        this.snackbar.success(err.message)
        this.loadingDelete = false
      },
      complete: () => {
        this.loadingDelete = false
      },
    })
  }

  statusItem(element: any) {
    this.addressService
      .editAddress({
        id: element.id,
        pessoaId: this.idPerson,
        tipoEnderecoId: element.tipoEnderecoId,
        cep: element.cep,
        logradouro: element.logradouro,
        numero: element.numero,
        complemento: element.complemento,
        bairro: element.bairro,
        estado: element.estado,
        cidade: element.cidade,
        pais: element.pais,
        latitude: element.latitude,
        longitude: element.longitude,
        ativo: element.ativo == 'Ativo' ? 'N' : 'S',
      })
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.snackbar.success(err.message)
        },
        complete: () => {
          this.uploadList()
        },
      })
  }

  clearItem() {
    this.item = {}
  }

  createModel(element: any) {
    let model: any = { pessoaId: this.idPerson }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }
}
